import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useState } from "react";

export function useDrawingManager(
  category: string = "",
  initialValue: google.maps.drawing.DrawingManager | null = null
) {
  const map = useMap();
  const drawing = useMapsLibrary("drawing");

  const [drawingManager, setDrawingManager] =
    useState<google.maps.drawing.DrawingManager | null>(initialValue);

  useEffect(() => {
    if (!map || !drawing) return;

    // https://developers.google.com/maps/documentation/javascript/reference/drawing
    const newDrawingManager = new drawing.DrawingManager({
      map,
      drawingMode: google.maps.drawing.OverlayType.POLYGON,
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [
          google.maps.drawing.OverlayType.POLYGON,
          google.maps.drawing.OverlayType.CIRCLE,
          google.maps.drawing.OverlayType.RECTANGLE,
        ],
      },
      circleOptions: {
        editable: true,
        fillColor: "#306fba",
        fillOpacity: 0.3,
        strokeColor: "lab(from #306fba calc(l - 5) a b / 1)",
        strokeWeight: 0,
      },
      polygonOptions: {
        editable: true,
        draggable: true,
        fillColor: "#306fba",
        fillOpacity: 0.3,
        strokeColor: "lab(from #306fba calc(l - 5) a b / 1)",
        strokeWeight: 0,
      },
      rectangleOptions: {
        editable: true,
        draggable: true,
        fillColor: "#306fba",
        fillOpacity: 0.3,
        strokeColor: "lab(from #306fba calc(l - 5) a b / 1)",
        strokeWeight: 0,
      },
    });

    setDrawingManager(newDrawingManager);

    return () => {
      newDrawingManager.setMap(null);
    };
  }, [drawing, map, category]);

  return drawingManager;
}
